import { createReactContext } from "#utils/reactContext";
import { PositionRowData } from "../StepComponents/SelectPositionsStep/SelectPositionsTable/types";

export type DistributionWorkflowContextType = {
  clientName: string;
  setClientName: (clientName: string) => void;
  distributionBatchId: number | null;
  setDistributionBatchId: (distributionBatchId: number) => void;
  investmentEntityName: string;
  setInvestmentEntityName: (investmentEntityName: string) => void;
  paymentDescription?: string;
  setPaymentDescription: (paymentDescription: string) => void;
  // Note: The date saved will be the user's local time. It will be converted to
  // the valid ET date at the time of create payment batch creation call since
  // we want to use the local date across the user's workflow.
  scheduledPaymentProcessDate: Date | null;
  setScheduledPaymentProcessDate: (date: Date) => void;
  makerNote?: string;
  setMakerNote: (makerNote: string) => void;
  selectedPositions: PositionRowData[];
  setSelectedPositions: (selectedPositions: PositionRowData[]) => void;
  numberOfAvailablePositions: number;
  setNumberOfAvailablePositions: (numberOfAvailablePositions: number) => void;
  errorMessage?: string;
};

const [useDistributionWorkflowContext, DistributionWorkflowContext] =
  createReactContext<DistributionWorkflowContextType>();
export { DistributionWorkflowContext, useDistributionWorkflowContext };
